import type { FunctionalComponent } from 'preact';
import type { StreamingService } from '@/types/webzine.ts';

/**
 * 스트리밍 서비스 링크.
 *
 * 시안은 SVG 를 인라인했지만(합계 28KB) `.service-icon` 스타일이 크기만 지정하고
 * 색은 건드리지 않아서, public/images/stream/<id>.svg 로 분리해 <img> 로 쓴다.
 */
export const StreamingLinks: FunctionalComponent<{ services: StreamingService[] }> = ({
  services,
}) => (
  <div class="streaming-secondary">
    <div class="streaming-secondary-grid">
      {services.map((service) => (
        <a
          key={service.id}
          class={`secondary-stream-service ${service.id}`}
          href={service.href}
          target="_blank"
          rel="noreferrer"
          aria-label={`${service.label}에서 듣기`}
        >
          <img class="service-icon" src={`/images/stream/${service.id}.svg`} alt={service.label} />
        </a>
      ))}
    </div>
  </div>
);
